/**
 * Pure string helpers (verbatim port of debugbase StringHelper). Despite the
 * "snake" names, snakeToCamelCase/snakeToClassName actually convert
 * kebab-case (dash-separated) strings — quirk preserved.
 */

export function snakeToCamelCase(str: string): string {
	return str.replace(/(\-\w)/g, function (m) {
		return m[1].toUpperCase();
	});
}

export function snakeToClassName(str: string): string {
	return capitalizeFirstLetter(snakeToCamelCase(str));
}

export function capitalizeFirstLetter(str: string): string {
	return str.charAt(0).toUpperCase() + str.slice(1);
}

export function contains(str: string, check: string, start: number = 0): boolean {
	return str.indexOf(check, start) !== -1;
}

export function remove(str: string, removeStr: string) {
	const re = new RegExp(escapeRegExp(removeStr), 'g');
	return str.replace(re, '');
}

export function isNumeric(str: string | number): boolean {
	return !isNaN(parseFloat(str as string)) && isFinite(str as number);
}

//Convert string to number or boolean
export function convert(str: string, convertBlankStringToBoolean: boolean = true): string | number | boolean {
	let converted: string | number | boolean = str;

	//If a blank string then most likely a boolean i.e created by attribute-name
	if ((convertBlankStringToBoolean && str === '') || str.toLowerCase() === 'true') {
		converted = true;
	} else if (str.toLowerCase() === 'false') {
		converted = false;
	} else if (isNumeric(str)) {
		converted = parseFloat(str);
	}
	return converted;
}

export function template(str: string, map: any): string {
	for (const i in map) {
		const re = new RegExp('%%' + i + '%%', 'g');
		str = str.replace(re, map[i]);
	}
	return str;
}

function escapeRegExp(str: string) {
	return str.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
